import { message } from 'antd';
import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWith409 from './baseQueryWith409';
import qs from 'qs';
import fetch from 'auth/FetchInterceptor';

// direct fetch without RTK Query
export const getPrCandidatos = query =>
	fetch.get(
		`/pr-candidatos${
			query
				? `?${qs.stringify(
						{ ...query, publicationState: 'live' },
						{
							encodeValuesOnly: true,
						}
				  )}`
				: ''
		}`
	);
export const getPrCandidato = ({ id, query }) =>
	fetch.get(
		`/pr-candidatos/${id}${
			query
				? `?${qs.stringify(
						{ ...query, publicationState: 'live' },
						{
							encodeValuesOnly: true,
						}
				  )}`
				: ''
		}`
	);
export const addPrCandidato = data => fetch.post('/pr-candidatos', data);
export const updatePrCandidato = ({ id, ...data }) =>
	fetch.put(`/pr-candidatos/${id}`, data);
export const deletePrCandidato = id => fetch.delete(`/pr-candidatos/${id}`);

// RTK Query
export const prCandidatosApi = createApi({
	reducerPath: 'prCandidatosApi',
	baseQuery: baseQueryWith409,

	// default configuration
	refetchOnReconnect: true,
	refetchOnMountOrArgChange: true,
	refetchOnFocus: true,

	//endpoints
	endpoints: build => ({
		getPrCandidatos: build.query({
			query: query => {
				return {
					url: `/pr-candidatos${
						query
							? `?${qs.stringify(
									{ ...query, publicationState: 'live' },
									{
										encodeValuesOnly: true,
									}
							  )}`
							: ''
					}`,
					method: 'GET',
				};
			},
			transformResponse: response => response.data,
			providesTags: result =>
				// is result available?
				result
					? // successful query
					  [
							...result.map(({ id }) => ({
								type: 'PrCandidatos',
								id,
							})),
							{ type: 'PrCandidatos', id: 'LIST' },
					  ]
					: // an error occurred, but we still want to refetch this query when `{ type: 'Posts', id: 'LIST' }` is invalidated
					  [{ type: 'PrCandidatos', id: 'LIST' }],
		}),
		getPrCandidato: build.query({
			query: ({ id, query }) => {
				return {
					url: `/pr-candidatos/${id}${
						query
							? `?${qs.stringify(
									{ ...query, publicationState: 'live' },
									{
										encodeValuesOnly: true,
									}
							  )}`
							: ''
					}`,
					method: 'GET',
				};
			},
			transformResponse: response => response.data,
			providesTags: (result, error, id) => [{ type: 'PrCandidatos', id }],
		}),
		addPrCandidato: build.mutation({
			query: data => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/pr-candidatos`,
					method: 'POST',
					body: JSON.stringify({
						data: {
							...data,
							created_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Proceso Candidato agregado exitosamente');
				} catch (error) {
					message.error('Error al agregar proceso candidato');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: [{ type: 'PrCandidatos', id: 'LIST' }],
		}),
		updatePrCandidato: build.mutation({
			query: ({ id, ...data }) => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/pr-candidatos/${id}`,
					method: 'PUT',
					body: JSON.stringify({
						data: {
							...data,
							updated_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Proceso Candidato actualizado exitosamente');
				} catch (error) {
					message.error('Error al actualizar proceso candidato');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: (result, error, { id }) => [
				{ type: 'PrCandidatos', id },
			],
		}),
		deletePrCandidato: build.mutation({
			query: id => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/pr-candidatos/${id}`,
					method: 'PUT',
					body: JSON.stringify({
						data: {
							publishedAt: null,
							updated_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Proceso Candidato eliminado exitosamente');
				} catch (error) {
					message.error('Error al eliminar proceso candidato');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: (result, error, id) => [{ type: 'PrCandidatos', id }],
		}),
	}),
});

export const {
	useGetPrCandidatosQuery,
	useLazyGetPrCandidatosQuery,
	useGetPrCandidatoQuery,
	useAddPrCandidatoMutation,
	useUpdatePrCandidatoMutation,
	useDeletePrCandidatoMutation,
} = prCandidatosApi;
